import React from 'react'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ApiUrl from '../../configTools/apiUrl';
import DocumentMeta from 'react-document-meta';

const Brandmap = () => {
    const meta = {
        /*title: 'New Arrivals | Latest & trendy Products on KAAY',
        description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
        */
        canonical: window.location.href
        /*canonical: 'http://example.com/path/to/page',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }*/
      }
    const [menu,setMenu] = useState([]);

    useEffect(() => {
        fetch(ApiUrl.API_URL_Brand)
        .then(res=>res.json())
        .then(data =>{
            setMenu(data);
        });
    },[])
  return (
    <div className='brandmap_wrapper'>
    <DocumentMeta {...meta} />
        <div className='brandmap_container'>
            {
                menu.map((item,index)=>{
                    return(
                        <Link to={'/brand/'+item.name} key={index}>
                            <div className='brandmap_container_item'>
                                <h6>{item.name}</h6>
                            </div>
                        </Link>
                    )
                })
            }
        </div>
    </div>
  )
}

export default Brandmap
